import http from 'utils/http';
import { IntraofficeNoteRequest, IntraofficeNoteResponse } from './types';
import { getIntraofficeNoteUrl, getIntraofficeNotesUrl } from './apiUrls';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getIntraofficeNotes(params: any): Promise<{ data: IntraofficeNoteResponse[]; meta: MetaApiResponse }> {
  return http.get(getIntraofficeNotesUrl(), params);
}

export function getIntraofficeNote(id: string): Promise<IntraofficeNoteResponse> {
  return http.get(getIntraofficeNoteUrl(id));
}

export function createIntraofficeNote(payload: IntraofficeNoteRequest): Promise<IntraofficeNoteResponse> {
  return http.post(getIntraofficeNotesUrl(), payload);
}

export function updateIntraofficeNote(id: string, payload: IntraofficeNoteRequest): Promise<IntraofficeNoteResponse> {
  return http.patch(getIntraofficeNoteUrl(id), payload);
}

export function deleteIntraofficeNote(id: string): Promise<string> {
  return http.delete(getIntraofficeNoteUrl(id));
}
